import { render, staticRenderFns } from "./Carriers.vue?vue&type=template&id=f3c4a6da&scoped=true&"
import script from "./Carriers.vue?vue&type=script&lang=js&"
export * from "./Carriers.vue?vue&type=script&lang=js&"
import style0 from "./Carriers.vue?vue&type=style&index=0&id=f3c4a6da&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c4a6da",
  null
  
)

export default component.exports